
import {
  defineComponent, computed, PropType,
} from 'vue';
import { useI18n } from 'vue-i18n';
import type { NoticeSeverity } from '@/composables/template-editor/useShopifyPasswordNotice';

export default defineComponent({
  name: 'NoticeBox',

  props: {
    severity: {
      type: String as PropType<NoticeSeverity>,
      default: 'info',
    },
    i18nKey: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const iconClass = computed(() => {
      switch (props.severity) {
        case 'warning': return 'fas fa-exclamation-circle';
        case 'danger': return 'fas fa-times-circle';
        case 'info':
        default: return 'fas fa-info-circle';
      }
    });

    const message = computed(() => t(props.i18nKey));

    return { iconClass, message };
  },
});
